module.exports = __webpack_public_path__ + "img/icon_cruise_head_3.e46ce02.png";